import get from 'lodash.get';

const getCustomFontPairs = (state) => get(state, 'ws.site.meta.customization.customFontPairs', []);

export default getCustomFontPairs;
